<template>
  <div :id="`wrapper-${inputId}`">
    <input
      :id="inputId"
      v-regexp="/^[\d\s]+$/"
      v-format-card
      :title="inputTitle"
      :value="value"
      :class="['ym-disable-keys', !isValid && 'invalid']"
      :data-position="position"
      type="tel"
      placeholder="0000 0000 0000 0000"
      autocomplete="cc-number"
      data-private
      @input="handleInput($event)"
    />

    <label :for="inputId">{{ $t('card.pan') }}</label>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import creditCardType from 'lib/utils/creditCardType';

import { luhn, prettyCardNumber } from '@/services/mixins';

const maxCardNumberLength = 20;

export default {
  mixins: [
    luhn,
    prettyCardNumber,
  ],
  props: {
    value: [Number, String],
    inputName: String,
    inputTitle: String,
    inputId: String,
  },
  data() {
    return {
      creditCardType: {},
      valueFormatted: this.value,
      isValid: true,
      position: 0,
    };
  },
  directives: {
    formatCard: {
      update(e) {
        if (e.dataset.position < e.selectionStart) {
          let currentPositionNumber = Number(e.dataset.position);
          if (currentPositionNumber + 1 === e.selectionStart) {
            currentPositionNumber += 1;
          }
          e.selectionStart = e.selectionEnd = Number(currentPositionNumber);
        }
      },
    },
  },
  computed: {
    isCardTypeDetected() {
      return Object.keys(this.creditCardType).length;
    },
    maxValue() {
      return this.isCardTypeDetected ? this.creditCardType.lengths[this.creditCardType.lengths.length - 1] : maxCardNumberLength;
    },
    isFilled() {
      return this.isCardTypeDetected && this.creditCardType.lengths.some(el => el === this.valueFormatted.length);
    },
    isLuhn() {
      return this.luhn(this.valueFormatted);
    },
    cardIsValid() {
      return this.isCardTypeDetected && this.isFilled && this.isLuhn && this.getAvailablePaymentSystems.includes(this.creditCardType.niceType.toUpperCase());
    },
    ...mapGetters(['getAvailablePaymentSystems']),
  },
  methods: {
    handleInput(e) {
      this.position = e.target.selectionStart;
      let formatted = e.target.value.replace(/\s*/gi, '');

      if (formatted.length > this.maxValue) {
        formatted = formatted.slice(0, -1);
        e.target.value = e.target.value.slice(0, -1);
      }

      this.valueFormatted = formatted;
      this.creditCardType = creditCardType(formatted).length === 1
        ? creditCardType(formatted)[0] : {};

      this.$emit('input', this.prettyCardNumber(formatted, this.creditCardType));
      this.validation();
    },
    validation() {
      if (!this.isCardTypeDetected) {
        return;
      }

      if (!this.getAvailablePaymentSystems.includes(this.creditCardType.niceType.toUpperCase())) {
        this.isValid = false;
        return;
      }

      if (this.valueFormatted.length <= 5) {
        this.isValid = true;
      } else if (!this.isCardTypeDetected) {
        this.isValid = false;
      } else if (this.valueFormatted.length < this.creditCardType.lengths[0]) {
        this.isValid = true;
      } else if (!this.cardIsValid) {
        this.isValid = false;
      } else {
        this.isValid = true;
        // this.valueFormatted.length >= 16 && this.$parent.$refs.androidBtnsManager.next();
        // temporary fix CPME-1114
        if (this.valueFormatted.length >= 16 && this.valueFormatted.length !== 17) {
          this.$emit('focusNext');
        }
      }
    },
  },
};
</script>
